import React from 'react'
import { TableCell, TableRow } from '@mui/material'

interface GenericHistoryTableRowProps {
    date: string
    content: string
    symbol?: string
    multipleInstrumentsExists?: boolean
    isSmallScreen: boolean
}

export const GenericHistoryTableRow = ({
    date,
    content,
    symbol = undefined,
    multipleInstrumentsExists = false,
    isSmallScreen,
}: GenericHistoryTableRowProps) => {
    return (
        <TableRow>
            <TableCell>{date}</TableCell>
            {multipleInstrumentsExists && !isSmallScreen ? <TableCell>{symbol}</TableCell> : null}
            <TableCell>{content}</TableCell>
            {!isSmallScreen ? (
                <>
                    <TableCell />
                    <TableCell />
                </>
            ) : null}
            <TableCell />
        </TableRow>
    )
}
